var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_119_928)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 25L23 31L33 19",
    stroke: "url(#paint1_linear_119_928)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_928",
    x1: -2.3283e-7,
    y1: 25.0001,
    x2: 50,
    y2: 25.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C66EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_119_928",
    x1: 17,
    y1: 25,
    x2: 33,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C66EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFrame);
export default __webpack_public_path__ + "static/media/tickFrame.1353ff427aecacf8c282cdd73730c2ae.svg";
export { ForwardRef as ReactComponent };